import React from 'react';
import type { PortalOnlyOfficeTheme } from './portalOnlyofficeTheme';

export interface OnlyofficeThemeSwitchProps {
  value: PortalOnlyOfficeTheme;
  onChange: (theme: PortalOnlyOfficeTheme) => void;
  className?: string;
}

const OPTIONS: { id: PortalOnlyOfficeTheme; label: string }[] = [
  { id: 'dark', label: 'Dunkel' },
  { id: 'light', label: 'Word (hell)' },
];

export const OnlyofficeThemeSwitch: React.FC<OnlyofficeThemeSwitchProps> = ({
  value,
  onChange,
  className = '',
}) => (
  <div
    className={`portal-shell-doc-mode flex gap-0.5 p-0.5 rounded-lg bg-white/[0.04] border border-white/[0.06] shrink-0 ${className}`}
    role="group"
    aria-label="OnlyOffice-Erscheinungsbild"
  >
    {OPTIONS.map((opt) => {
      const selected = value === opt.id;
      return (
        <button
          key={opt.id}
          type="button"
          aria-pressed={selected}
          onClick={() => onChange(opt.id)}
          className={`px-2.5 py-1 rounded-md text-[11px] font-medium transition-colors whitespace-nowrap ${
            selected ? 'bg-white/[0.1] text-slate-100' : 'text-slate-500 hover:text-slate-300'
          }`}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);
